import { ApiAccount } from '../../../openapi';

export function getExchangeAccounts({
  defaultAccountId,
  accounts,
}: {
  defaultAccountId: string | undefined;
  accounts: ApiAccount[];
}): {
  from: ApiAccount | undefined;
  to: ApiAccount | undefined;
} {
  let from: ApiAccount | undefined;
  if (defaultAccountId) {
    from = accounts.find((it) => it.id === defaultAccountId);
  }
  if (!from) {
    from = accounts.find((it) => it.purpose === 'BASE');
  }
  if (from) {
    const fromId = from.id;
    const to = accounts.find((it) => it.id !== fromId);
    return { from, to };
  }

  // actually impossible
  if (accounts.length < 2) return { from: undefined, to: undefined };

  return { from: accounts[0], to: accounts[1] };
}
